const CLEAR_ID: string = '__clear-select-item__';
const MIN_WIDTH: number = 50;

export {
  CLEAR_ID,
  MIN_WIDTH,
};
